<template>
  <div class="footer">
    <div class="footer__header" v-if="$route.name !== 'requests' && $route.name !== 'search'">
      <div class="container">
        <div class="footer__item footer__item--first">
          <h3>{{ $t('cTA') }}</h3>
        </div>

        <div class="footer__item-wrapper">
          <div class="footer__item footer__item--second">
            <button class="footer__item__link btn" @click="showPhoneModal">
              <span class="text">{{ $t('callUs') }}</span>
            </button>
            <transition name="fade">
              <div
                  v-if="isOpenPhoneModal"
                  class="footer__item__modal"
                  @mouseover="isHovering"
                  @mouseleave="notHovering"
                  v-on:blur="inputBlur"
              >
                <span class="footer__modal-exit-icon" @click="isOpenPhoneModal = !isOpenPhoneModal">&#88;</span>
                <div>
                  <h2 class="footer__modal-title">{{ $t('callUs') }}</h2>
                  <a class="footer__modal-link" :href="`tel:${localNumber}`">
                    <h2 class="footer__modal-link-text">{{ localNumber }} {{ $t('callNumberText1') }}</h2>
                  </a>
                </div>

                <div class="">
                  <a class="footer__modal-link" :href="`tel:+1-${internationalNumber}`">
                    <h2 class="footer__modal-link-text">
                      {{ internationalNumber }} {{ $t('callNumberText2') }}
                    </h2>
                  </a>
                </div>
              </div>
            </transition>
          </div>

          <div class="footer__item footer__item--third">
            <button class="footer__item__link btn" @click="startChat">
              <span class="text">{{ $t('startLiveChat') }}</span>
            </button>
            <transition name="fade">
              <div
                  v-if="isOpenChatModal"
                  class="footer__item__modals"
                  @mouseover="isHovering"
                  @mouseleave="notHovering"
                  v-on:blur="inputBlur"
              >
                <span class="footer__modal-exit-icon" @click="isOpenChatModal = !isOpenChatModal">&#88;</span>
                <div>
                  <h2 class="footer__modal-title">{{ $t('chatModalTitle') }}</h2>
                  <h2 class="footer__modal-subtitle">{{ $t('chatModalSubTitle') }}</h2>
                  <ul class="footer__modal-options">
                    <li class="footer__modal-option">
                      <a class="footer__modal-link" :href="chatLinkThree">{{ $t('popQues3') }}</a>

                    </li>
                    <li class="footer__modal-option">
                      <router-link class="footer__modal-link"
                                   :to="{name: 'article', hash:`#${$store.state.flowObject.variables.popularQuestions[0]}-${chatLinkOne.title.replace(/ /g, '-')}`}"
                      >{{ $t('popQues1') }}
                      </router-link>
                    </li>
                    <li class="footer__modal-option">
                      <router-link class="footer__modal-link"
                                   :to="{name: 'article', hash:`#${$store.state.flowObject.variables.popularQuestions[1]}-${chatLinkTwo.title.replace(/ /g, '-')}`}"
                      >{{ $t('popQues2') }}
                      </router-link>
                    </li>
                  </ul>
                  <h2 class="footer__modal-subtitle">{{ $t('chatModalSubTitleFooter') }}</h2>
                  <div class="footer__modal-option">
                    <a @click="startChat" class="footer__modal-divnk">{{ $t('startChat') }}</a>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <div class="footer__body">
      <div class="container">
        <div class="footer__body__inner">
          <div
              v-if="helpcenter_type === 'vpn'"
              v-html="$t('vpnDisclaimer', { siteName: capitalizeSitename, termsLink: termsLink, privacyLink: privacyLink })"
              class="text footer-text footer-text-zeus"
          ></div>
          <div
              v-else
              v-html="$t('footerText', { siteName: capitalizeSitename, termsLink: termsLink, privacyLink: privacyLink })"
              class="text footer-text footer-text-zeus"
          ></div>
        </div>
        <div class="footer-nav">
          <ul class="list footer-links">
            <li>
              <router-link class="link" :to="{ name: 'home' }">{{ $t('support') }}</router-link>
            </li>
            <li>
              <a class="link" :href="aboutLink">{{ $t('aboutLink') }}</a>
            </li>
            <li>
              <router-link class="link" :to="{ name: 'requests' }">{{ $t('contact') }}</router-link>
            </li>
            <li>
              <a class="link" :href="loginLink">{{ $t('loginLinkText') }}</a>
            </li>
          </ul>
          <p
              v-html="$t('footerCopyright', { siteName: capitalizeSitename, currentYear: currentYear })"
              class="text copyright"
          ></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  trackPageClick,
  capitalize,
  getCountryCode,
  available_countries,
  high_priority_countries,
  low_priority_countries,
  getStorage,
  replaceMaHcLoginSupportContent,
  getSpecificArticleFromStore,
  getLocalPhoneNumberByCountry
} from '@/utils/common';
// TODO:
export default {
  data() {
    return {
      phoneModalVisible: false,
      isOpenPhoneModal: false,
      isOpenChatModal: false,
      hovering: false,
      localNumberText: null,
      isTollFree: false,
      isPriority: false
    };
  },
  created() {
    getCountryCode();
    this.getLocalNumber();
    replaceMaHcLoginSupportContent();
  },
  computed: {
    helpcenter_type() {
      return this.$store.state.siteDetails.helpcenter_type
    },
    siteName() {
      return this.$store.state.siteDetails.site_name;
    },
    aboutLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/about-us`;
    },
    contactLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/contact`;
    },
    loginLink() {
      return `https://members.${this.$store.state.siteDetails.domain_name}/login`;
    },
    termsLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/terms`;
    },
    privacyLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/privacy`;
    },
    usCanadaNumber() {
      return this.$store.state.siteDetails.support_number_us_canada;
    },
    capitalizeSitename() {
      return capitalize(this.siteName);
    },
    internationalNumber() {
      return this.$store.state.siteDetails.corp_info.us_phone_number;
    },
    localNumber() {
      this.localNumberText = this.getLocalNumber();
      return this.localNumberText;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    chatLinkOne() {
      const question = getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[0]);
      return question || {title: ''};
    },
    chatLinkTwo() {
      const question = getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[1]);
      return question || {title: ''};
    },
    chatLinkThree() {
      return `https://members.${this.$store.state.siteDetails.domain_name}/account/recovery`;
    },
  },
  methods: {
    startChat() {
      this.$gtm.dataLayer().push({
        event: 'Load Chatbot'
      });
      //this.showChatModal();
    },
    trackPageClick,
    showPhoneModal() {
      this.isOpenPhoneModal = !this.isOpenPhoneModal;
      if (this.isOpenChatModal) {
        this.isOpenChatModal = !this.isOpenChatModal;
      }
    },
    showChatModal() {
      this.isOpenChatModal = !this.isOpenChatModal;
      if (this.isOpenPhoneModal) {
        this.isOpenPhoneModal = !this.isOpenPhoneModal;
      }
    },
    inputBlur() {
      if (!this.hovering) {
        this.isOpenPhoneModal = false;
      }
    },
    isHovering() {
      this.hovering = true;
    },
    notHovering() {
      this.hovering = false;
    },
    getLocalNumber() {
      return getLocalPhoneNumberByCountry();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/zeus-design.scss';

.footer__header {
  background: #fff;
  padding: 60px 0;
  text-align: center;
  h3 {
    font-family:  Segoe UI, Arial, sans-serif;
    font-size: 40px;
    font-weight: 300;
    margin: 0 0 30px;
    color: #333;
  }
}

.footer__item-wrapper {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  position: relative;
  flex-wrap: wrap;
  .btn {
    margin: 0 8px;
  }
}
.footer__item {
  position: relative;
}

.footer__modal-exit-icon {
  position: absolute;
  right: 10px;
  top: 8px;
  font-weight: 500;
  cursor: pointer;
}

.footer__item__modal {
  position: absolute;
  background: #fff;
  padding: 30px 25px 25px;
  width: 322px;
  border-radius: 20px;
  left: 0;
  bottom: 60px;
  box-shadow:  0px 4px 40px rgba(0, 0, 0, 0.1);
}

.footer__item__modals {
  position: absolute;
  background: #fff;
  padding: 30px 25px 25px;
  width: 322px;
  border-radius: 20px;
  left: 0;
  bottom: 60px;
  box-shadow:  0px 4px 40px rgba(0, 0, 0, 0.1);
}

.footer__modal-title {
  font-size: 18px;
  color: #444;
  margin: 0 0 10px;
  text-align: left;
}

.footer__modal-subtitle {
  font-size: 14px;
  font-weight: 300;
  color: #333;
  text-align: left;
  &:last-of-type {
    font-size: 18px;
    font-weight: 400;
  }
}

.footer__modal-link {
  text-decoration: none;
}

.footer__modal-link-text {
  font-size: 20px;
  color: #444;
  font-weight: 300;
  margin: 0 0 5px;
  text-align: left;
}

.footer__modal-options {
  padding: 0;
  margin: 0;
  list-style: none;
}

.footer__modal-option {
  font-size: 16px;
  text-align: left;
  margin: 0 0 10px;
}

.footer__modal-option a {
  color: #287EFF;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.footer__body {
  background: #F5F5F7;
  padding: 60px 0;
}
.footer__body__inner {
  margin: 0 0 50px;
  .text {
    font-size: 16px;
    color: #747474;
    font-weight: 300;

  }
}
.footer-nav {
  display: flex;
  justify-content: space-between;
  .footer-links {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  li {
    display: inline-block;
    vertical-align: top;
    margin: 0 20px 0 0;
  }
  a {
    color: #333333;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  .text {
    font-size: 14px;
    margin: 0;
    color: #747474;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
@media (max-width: 768px) {
  .footer__header {
    padding: 40px 0;
    h3 {
      font-size: 25px;
    }
  }
  .footer__item-wrapper {
    justify-content: center;
    flex-direction: column;
    .btn {
      margin: 0 0 10px;
    }
  }
  .footer__item__modal {
    width: 290px;
    left: 50%;
    transform: translateX(-50%);
  }
  .footer__item__modals {
    width: 290px;
    left: 50%;
    transform: translateX(-50%);
  }
  .footer__modal-link-text {
    font-size: 16px;
  }
  .footer__modal-option {
    font-size: 16px;
  }
  .footer__modal-subtitle {
    &:last-of-type {
      font-size: 16px;
    }
  }
  .footer__body {
    padding: 40px 0;
  }
  .footer-nav {
    flex-direction: column;
    justify-content: center;
    text-align: center;
      .footer-links {
        margin: 0 0 20px;
      }
  }
  .footer__body__inner .text {
    text-align: center;
  }
}

</style>
